// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

const initialNavigation = () => {
  const item = "Bem vindo!";
  return item ? item : {};
};

const initiaIconlNavigation = () => {
  const item =
    "https://cdn-jupiter.s3.amazonaws.com/ctplus/modulos/logo-connect.png";
  return item ? item : {};
};

export const navigationSlice = createSlice({
  name: "navigationStep",
  initialState: {
    initialStep: initialNavigation(),
    iconinitialStepNavigation: initiaIconlNavigation(),
    secondStepNavigation: "",
    iconSecondStepNavigation: "",
    thirdStepNavigation: "",
    sessionTimer: 14.9,
  },
  reducers: {
    handleNavigation: (state, action) => {
      state.initialStep = action.payload;
    },
    handleIconInitalNavigation: (state, action) => {
      state.iconinitialStepNavigation = action.payload;
    },
    handleNavigationSecond: (state, action) => {
      state.secondStepNavigation = action.payload;
    },
    handleIconSecondStepNavigation: (state, action) => {
      state.iconSecondStepNavigation = action.payload;
    },
    handleNavigationThird: (state, action) => {
      state.thirdStepNavigation = action.payload;
    },
    handleSessionTimer: (state, action) => {
      state.sessionTimer = action.payload;
    },
  },
});

export const {
  handleNavigation,
  handleNavigationSecond,
  handleIconSecondStepNavigation,
  handleIconInitalNavigation,
  handleNavigationThird,
  handleSessionTimer,
} = navigationSlice.actions;

export default navigationSlice.reducer;
